import { NavigationEntryContext } from 'contexts/navigation-entry'
import { useContext } from 'react'
import { useNavigate } from 'react-router'
import { useLocation } from 'react-router-dom'
import { NavigationEntry, NavigationRoute } from 'services/types'
import routes from '../app-routes'
import { AppStateType } from 'services/enums';
import { useRequestCache } from 'services/useRequestCache'

export const useNavigation = () => {
    const navigate = useNavigate()
    const navContext = useContext(NavigationEntryContext)
    let location = useLocation()
    const { sendCacheAppState } = useRequestCache()

    const initialNavigationSetup = async (): Promise<void> => {
        let ids: number[] = navContext.navigationEntries.map(x => x.id!)
        navContext.navigationEntries.bulkRemove(ids)
        const initialEntry: NavigationEntry = { id: routes[0].id, url: '/' + routes[0].path.substring(1), path: '/' + routes[0].path.substring(1) } //add first page to navigation stack        
        navContext.navigationEntries.put(initialEntry)

        const dbRoutes: NavigationRoute[] = routes.map(route => {
            const dbRoute = { ...route, component: route.component.name }
            return dbRoute
        })

        navContext.navigationRoutes.set(dbRoutes)
    }

    const customTitle = (): string | null => {
        let navigationStack: NavigationEntry[] = navContext.navigationEntries.toArray() ?? []
        let lastEntry: NavigationEntry | undefined = navigationStack?.length > 0 ? navigationStack[navigationStack.length - 1] : undefined
        const navigationRoute: NavigationRoute | undefined = navContext.navigationRoutes.find(r => r.id == lastEntry?.id)
        const title: string | null = navigationRoute == undefined ? null : navigationRoute.title
        return title
    }

    const removeNavigateEntries = (navigateBackPath: string): void => {
        let navigationStack: NavigationEntry[] = navContext.navigationEntries.toArray() ?? []
        let entryIndex: number | undefined = navigationStack != null ? navigationStack.findIndex(n => n.path == navigateBackPath) : undefined
        var removeEntries: NavigationEntry[] | undefined = navigationStack.splice(entryIndex! + 1, navigationStack.length - 1) ?? undefined
        removeEntries != undefined && navContext.navigationEntries.bulkRemove(removeEntries.map(l => l.id))
    }

    const navigateTo = async (url: string, title?: string, navigateBackPath?: string, fromBrowserEvent?: boolean): Promise<void> => {

        const relativeUrl = url[0] === '/' ? url : `/${url}`
        const splitPath: string[] = relativeUrl.split("?", 2)
        const pathName = splitPath[0]
        let route = navContext.navigationRoutes.find(r => r.path == pathName)

        if (fromBrowserEvent) {
            if (navContext.navigationEntries.length > 0) {
                const newEntry: NavigationEntry = { id: route?.id!, url: relativeUrl, path: pathName }
                navContext.navigationEntries.put(newEntry) //add or update navigation stack
            }
            else {
                initialNavigationSetup();
                let defaultEntry = navContext.navigationEntries.get(0);
                if (defaultEntry != null) {
                    navigateTo(defaultEntry.path);
                }
            }
            return
        }
        if (navigateBackPath != null) {
            removeNavigateEntries(navigateBackPath)
        }
        const newEntry: NavigationEntry = { id: route?.id!, url: relativeUrl, path: pathName }

        if (navContext.navigationEntries.length > 0) {
            let navigationStack: NavigationEntry[] = navContext.navigationEntries.toArray() ?? []
            navigationStack.forEach(order => {
            })

        }
        if (route != undefined && title != undefined) {
            route.title = title;
            navContext.navigationRoutes.put(route) //update custom title
        }
        navContext.navigationEntries.put(newEntry) //add or update navigation stack
        if (location.pathname == pathName) {
            await navigate(relativeUrl, { replace: true })
        }
        else {
            await navigate(relativeUrl);
        }
    }

    const navigateBack = async (navigateBackPath?: string, removeFromStackOnly?: boolean): Promise<void> => {
        let navigationStack: NavigationEntry[] = navContext.navigationEntries.toArray() ?? []
        let removeLastEntry = undefined
        let navigateBackTo = undefined

        if (removeFromStackOnly == true) {
            removeLastEntry = navigationStack?.length > 0 ? navigationStack[navigationStack.length - 1] : undefined
            removeLastEntry != undefined && navContext.navigationEntries.remove(removeLastEntry.id)
            return
        }
        else {
            if (navigateBackPath != null) {
                removeNavigateEntries(navigateBackPath)
                navigateBackTo = navigationStack?.length > 0 ? navigationStack[navigationStack.length - 1] : undefined
                navigateBackTo != undefined && await navigate(navigateBackTo.url)
            }
            else {
                removeLastEntry = navigationStack?.length > 0 ? navigationStack[navigationStack.length - 1] : undefined
                removeLastEntry != undefined && navContext.navigationEntries.remove(removeLastEntry.id)
                navigateBackTo = navigationStack?.length > 1 ? navigationStack[navigationStack.length - 2] : undefined
                if (navigateBackTo != null) {
                    await navigate(navigateBackTo.url)
                }
                else {
                    await navigate('load-assignments', { replace: true });
                }
            }
        }

        if (removeLastEntry == undefined && navigateBackTo == undefined) {
            /* This logic should happens only if for some reason the navigation stack got cleared */
            const type: AppStateType = AppStateType.IssueReport;
            var comment = "Trying to navigateBack but the navigationStack is cleared.";

            await sendCacheAppState(type, comment);

            await navigate('load-assignments', { replace: true });
        }
    }

    return {
        initialNavigationSetup: initialNavigationSetup,
        removeNavigateEntries: removeNavigateEntries,
        customTitle: customTitle,
        navigateTo: navigateTo,
        navigateBack: navigateBack
    }
}
